import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Answer {
  questionId: string;
  question: string;
  answer: string;
  displayOrder: number;
}
export interface PagedApplicationsResponse {
  applications: {
    content: JobApplication[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
  };
  positions: string[];
}

export interface JobApplication {
  id: string;
  jobPostId: string;
  positionTitle: string;
  companyName: string;
  userId: string;
  applicantName: string;
  applicantEmail: string;
  cvUrl: string;
  answers: Answer[];
  status: string;
  appliedAt: string;
  updatedAt: string;
  notes?: string; // Optional field for HR notes
  jobPostTitle: string;
}

export type TabType = 'all' | 'submitted' | 'other';

export interface FilterState {
  status: string;
  positionTitle: string;
}

@Injectable({
  providedIn: 'root',
})
export class JobApplicationServiceService {
  private baseUrl = environment.apiUrl;
  private companyId = localStorage.getItem('userId') || '';
  constructor(private http: HttpClient) {}

  getCompanyApplications(): Observable<JobApplication[]> {
    return this.http.get<JobApplication[]>(
      `${this.baseUrl}api/job-applications/company`,
    );
  }

  getPositionTitles(applications: JobApplication[]): string[] {
    return [...new Set(applications.map((a) => a.positionTitle))].sort();
  }

  getStatuses(applications: JobApplication[]): string[] {
    return [...new Set(applications.map((a) => a.status))].sort();
  }

  getApplicationDetails(id: string): Observable<JobApplication> {
    return this.http.get<JobApplication>(
      `${this.baseUrl}api/job-applications/${id}`,
    );
  }

  updateApplicationStatus(
    data: { status: string; notes?: string },
    id: string,
  ): Observable<any> {
    // Filter out undefined/null/empty values before sending to backend
    const payload = Object.fromEntries(
      Object.entries(data).filter(
        ([_, value]) => value !== undefined && value !== null && value !== '',
      ),
    );

    return this.http.patch(
      `${this.baseUrl}api/job-applications/${id}`,
      payload,
    );
  }
  searchApplications(
    search: string,
    page = 0,
    size = 10,
  ): Observable<PagedApplicationsResponse> {
    return this.http.get<PagedApplicationsResponse>(
      `${this.baseUrl}api/job-applications/company/${this.companyId}/search?search=${encodeURIComponent(search)}&page=${page}&size=${size}`,
    );
  }

  // Filter endpoint
  filterApplications(
    filters: { status?: string; position?: string },
    page = 0,
    size = 10,
  ): Observable<PagedApplicationsResponse> {
    let url = `${this.baseUrl}api/job-applications/company/${this.companyId}/filter?page=${page}&size=${size}`;
    if (filters.status) url += `&status=${encodeURIComponent(filters.status)}`;
    if (filters.position)
      url += `&position=${encodeURIComponent(filters.position)}`;
    return this.http.get<PagedApplicationsResponse>(url);
  }

  sendInterviewInvite(jobApplicationId: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}api/b2b/interview/${jobApplicationId}/invite`,
      {},
    );
  }
}
